export default __webpack_public_path__ + "img/Montserrat-ExtraBold_0697040.ttf";